import React, { Component } from "react";

class ExclusiveMode extends Component {
    constructor(props) {
        super(props);
    }

    addExclusiveMode (event) {
        let value = event.target.dataset.value;
        let checked = event.target.checked;

        if (checked) {
            this.props.addModoExclusivo(parseInt(value));
        } else {
            this.props.deleteModoExclusivo(parseInt(value));
        }
    }

    render() { 
        if(this.props.productos == undefined)
            return null;

        let productos = this.props.productos.filter( x => x.Id >= 0);
        productos = productos.map((prod) => {
            prod.Checked = this.props.modoExclusivo.find(function (xm) {
                return xm == prod.Id
            }) != undefined;

            return (
                <div className="checkbox-container">
                    <input type="checkbox" checked={prod.Checked}
                        value={() => this.props[prod.Descripcion + prod.Id]()}
                        data-value={prod.Id} id={prod.Descripcion + prod.Id}
                        onClick={(event) => this.addExclusiveMode(event)} />
                    <label htmlFor={prod.Descripcion + prod.Id}>{prod.Descripcion}</label>
                </div>
            );
        });

        return (
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Accede en modo exclusivo <span className="optional">(opcional)</span></label>
                </div>
                <div className="col-xs-12 bottom-separator-xxs">
                    <label className="label-primary">Seleccione un producto...</label>
                </div>
                <div className="col-xs-12">
                    {productos}
                </div>
            </div>
        );
    }
}

export default ExclusiveMode;